import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { CheckoutRequest, CheckoutEnterpriseRequest, LeadEnterpriseRequest, ValidarTokenEnterpriseResponse } from 'app/shared/models/ei-models';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Checkout/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  realizarCheckout(checkout: CheckoutRequest, loader = true): Observable<any> {
    return this.httpClient.post<any>(
      this.controllerEndpoint.concat('RealizarCheckout'),
      checkout,
      { headers: this.getHeader(loader) }
    );
  }

  enviarLeadEnterprise(lead: LeadEnterpriseRequest, loader = true): Observable<any> {
    return this.httpClient.post<any>(
      this.controllerEndpoint.concat('EnviarLeadEnterprise'),
      lead,
      { headers: this.getHeader(loader) }
    );
  }

  /**
   * Valida o token de checkout Enterprise e retorna os dados do lead.
   * @param token Token recebido via URL
   */
  validarTokenEnterprise(token: string, loader = true): Observable<ValidarTokenEnterpriseResponse> {
    return this.httpClient.get<ValidarTokenEnterpriseResponse>(
      this.controllerEndpoint.concat('ValidarTokenEnterprise/', token),
      { headers: this.getHeader(loader) }
    );
  }

  /**
   * Finaliza o checkout Enterprise com os dados completos.
   * @param request Dados do checkout com token
   */
  finalizarCheckoutEnterprise(request: CheckoutEnterpriseRequest, loader = true): Observable<any> {
    return this.httpClient.post<any>(
      this.controllerEndpoint.concat('FinalizarCheckoutEnterprise'),
      request,
      { headers: this.getHeader(loader) }
    );
  }
}